<template>
  <div class="structengine-app">
    <!-- Hero Section Component -->
    <hero-section
      :metrics-visible="metricsVisible"
      @scroll-to-calculators="scrollToCalculators"
    />

    <!-- Features Section Component -->
    <features-section />

    <!-- CTA Section Component -->
    <cta-section
      @cta-visible="handleCtaVisible"
      @navigate-to="navigateTo"
    />

    <!-- Error Snackbar -->
    <v-snackbar v-model="errorMessage.show" color="error" location="top" timeout="5000">
      {{ errorMessage.text }}
      <template #actions>
        <se-button variant="text" @click="errorMessage.show = false">Close</se-button>
      </template>
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import SeButton from '@/components/SEButton.vue'
import { HeroSection, CtaSection, FeaturesSection } from '@/components/homepage'

const router = useRouter()

// State
const metricsVisible = ref(false)
const errorMessage = ref({ show: false, text: '' })

// Methods
const navigateTo = async (path: string) => {
  try {
    await router.push(path)
  } catch (err) {
    errorMessage.value = { show: true, text: 'Navigation failed. Please try again.' }
    console.error(err)
  }
}

const scrollToCalculators = () => {
  document.getElementById('calculators')?.scrollIntoView({ behavior: 'smooth' })
}

const handleCtaVisible = (visible: boolean) => {
  if (visible && import.meta.env.DEV) console.log('CTA section visible')
}
</script>

<style scoped>
/* Using unified theme system - much cleaner! */
.structengine-app {
  background: var(--bg-canvas);
  color: var(--text-body);
}

/* Simplified styles using theme variables */
.features-section {
  padding: 3rem 0 1rem;
  background: var(--bg-canvas);
}

.final-cta-section {
  padding: 4rem 0;
  background: var(--bg-surface);
  text-align: center;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 24px;
}

.cta-title {
  font-size: var(--font-size-display);
  font-weight: 700;
  margin-bottom: 16px;
  color: var(--text-primary);
}

.cta-subtitle {
  font-size: var(--font-size-xl);
  color: var(--text-body);
  margin-bottom: 48px;
}

.cta-actions {
  display: flex;
  gap: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-primary,
.cta-secondary {
  font-size: var(--font-size-lg);
  padding: 16px 32px;
  border-radius: var(--radius-lg);
  font-weight: 600;
  transition: all 0.3s ease;
}

.cta-primary:hover,
.cta-secondary:hover {
  transform: translateY(-2px);
}

/* Mobile Responsiveness */
@media (max-width: 767px) {
  .cta-actions {
    flex-direction: column;
    gap: 16px;
  }

  .testimonials-grid {
    grid-template-columns: 1fr;
  }
}
</style>
